import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { Partner } from 'src/app/models/Partner';

import { ArchivePartner } from '../partners.actions';

@Component({
    selector: 'app-partner-delete-modal',
    templateUrl: './partner-delete-modal.component.html',
    styleUrls: ['./partner-delete-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PartnerDeleteModalComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Input() partner: Partner;
    @Input() partnerDetailModal: NgbActiveModal;

    constructor(public activeModal: NgbActiveModal, private store: Store, private router: Router, private logger: NGXLogger) {}

    ngOnInit(): void {}

    archivePartner() {
        this.logger.debug('Attempt to archive partner');
        this.subscriptions.add(
            this.store.dispatch(new ArchivePartner(this.partner.uuid)).subscribe(
                () => {
                    this.logger.debug('Succesfully archived partner');
                    this.partnerDetailModal ? this.partnerDetailModal.close() : () => {};
                    this.activeModal.close();
                    this.logger.debug('Navigating to partners');
                    this.router.navigate(['/partners']);
                },
                (error) => this.logger.error('Failed to archive partner'),
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
